import { css } from "@emotion/react";

import * as dimensions from "@styles/emotion-styles/dimensions";

export const BrandsBox = css`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(6, auto);
  grid-auto-flow: column;
  grid-gap: 1rem;
  @media (max-width: ${dimensions.widescreenMax}) {
    width: fit-content;
  }
`;

export const FullWidth = css`
  @media (max-width: ${dimensions.widescreenMax}) {
    width: 100%;
  }
`;
export const PopularBrandsContainer = css`
  @media (max-width: ${dimensions.widescreenMax}) {
    margin-left: 1rem;
  }
  @media (min-width: ${dimensions.widescreenMax}) {
    margin-left: 3rem;
  }
`;

export const SeeAllButton = css`
  width: 65%;
  grid-row-start: span 2;
  grid-row-end: auto;
  display: flex;
  align-self: flex-end;
`;
